import axios from 'axios';
import { URL_API } from './default';

//'https://rumbopunilla.com/Api/public/'
//localhost:8787
// Default config options
const token = localStorage.getItem('token');

export const myHeaders = `Bearer ${token}`;

const defaultOptions = {
    baseURL: URL_API,
    headers: {
      "Content-Type": "multipart/form-data", 
    },
  };

  // Create instance
  const clienteAxios = axios.create(defaultOptions);

  // Set the AUTH token for any request
  clienteAxios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
  });

export default clienteAxios;